import { apiLocationGeocodeRetrieve } from '@rover/rsdk/src/apiClient/latest/api-location-geocode-retrieve';

// locationType values (from common/geocode/constants.py) too broad to anchor a name search.
export const REJECTED_LOCATION_TYPES = new Set(['state', 'country']);

export type LocationResolution =
  | { ok: true; lat: string; lng: string; postalCode: string | null; locationType: string | null }
  | { ok: false; reason: 'not_found' | 'too_broad' };

type GeocodeCoords = {
  lat?: string | null;
  lng?: string | null;
  locationType?: string | null;
  postalCode?: string | null;
} | null;

// Unresolvable input geocodes to empty-string coords, not null — check truthiness, never `!= null`.
export const classifyCoords = (coords: GeocodeCoords): LocationResolution => {
  if (!coords || !coords.lat || !coords.lng) return { ok: false, reason: 'not_found' };
  if (coords.locationType && REJECTED_LOCATION_TYPES.has(coords.locationType)) {
    return { ok: false, reason: 'too_broad' };
  }
  return {
    ok: true,
    lat: coords.lat,
    lng: coords.lng,
    postalCode: coords.postalCode ?? null,
    locationType: coords.locationType ?? null,
  };
};

// A thrown or empty geocode resolves to not_found so callers surface one "not found" error.
export const resolveLocation = async (query: string): Promise<LocationResolution> => {
  try {
    return classifyCoords(await apiLocationGeocodeRetrieve({ query }));
  } catch {
    return { ok: false, reason: 'not_found' };
  }
};
